module.exports = __webpack_public_path__ + "static/media/bg7.982137bd.jpg";